import { IconArrowRightOutline } from '@icons/IconArrowRightOutline'
import { IconTransformOutline } from '@icons/IconTransformOutline'
import { Button } from '@/components/shadcn/button'
import { ComposedSheet } from '@/components/ui/ComposedSheet'
// import { IconBg } from '@/components/ui/IconBg'
import { stateMap } from './stateMap'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { TooltipWrapper } from '@/components/ui/TooltipWrapper'
import { RestSchemas } from '@/contexts/QueryProvider'
import { useDownloadFile } from '../TemplatesV2/useDownloadFile'
import { ActivityLogV2 } from './ActivityLogV2/ActivityLogV2'
import { MessagesStorageStorageFileType } from '@/util/enums'
import { IconV2AttachmentOutline } from '@icons/IconV2AttachmentOutline'
import { IconV2FormOutline } from '@icons/IconV2FormOutline'
import { Badge } from '@/components/shadcn/badge'

type DataAssetItemProps = {
  groupName: string
  parentName: string
  item: RestSchemas['Messages.DataAssets.TDataAssetActivity']
}

export function DataAssetItem({ groupName, parentName, item }: DataAssetItemProps) {
  const { mutate: downloadFile, isPending } = useDownloadFile()
  const hasDownloadableFile = !!item.file_name && !!item.url
  const validState = item.state && item.state in stateMap ? (item.state as keyof typeof stateMap) : 'None'
  // const StateIcon = stateMap[validState].icon
  const stateVariant = stateMap[validState].variant

  const handleDownloadFile = () => {
    if (!item.url) return
    downloadFile({ url: item.url, fileName: item.file_name, fileType: MessagesStorageStorageFileType.Result })
  }

  return (
    <div className="grid grid-cols-[max-content_minmax(0,1fr)_min-content_min-content] gap-x-1 overflow-hidden">
      <div className="font-semibold">
        {item.data_asset.name}
        {hasDownloadableFile ? ':' : null}
      </div>
      {hasDownloadableFile ? (
        <TooltipButton tooltip={`Download '${item.file_name}'`}>
          <Button
            variant="ghost"
            className="h-auto w-full justify-start truncate p-0 underline underline-offset-2"
            onClick={handleDownloadFile}
            disabled={isPending}
          >
            <IconV2AttachmentOutline size={16} className="ml-1 flex-shrink-0 text-foreground" />
            <span className="truncate font-light underline underline-offset-2">{item.file_name}</span>
            {isPending && <IconTransformOutline size={16} className="ml-1 flex-shrink-0 text-foreground" />}
          </Button>
        </TooltipButton>
      ) : (
        <div />
      )}
      <Badge variant={stateVariant}>{stateMap[validState].name}</Badge>
      {/* <IconBg tooltip={stateMap[validState].name} variant={stateVariant} className="size-5">
        <StateIcon size={12} />
      </IconBg> */}
      <div className="flex items-center gap-1 pl-5">
        <TooltipWrapper
          tooltip={`Actions & activity log`}
          wrapTrigger
          triggerComponent={
            <ComposedSheet
              // title={`${groupName} | ${item.file_template.name}`}
              description={
                <span className="flex items-center gap-2">
                  {groupName}
                  <IconArrowRightOutline size={10} />
                  {parentName}
                  <IconArrowRightOutline size={10} />
                  {item.data_asset.name}
                </span>
              }
              title={`Actions & activity log`}
              wide
              trigger={undefined}
            >
              <ActivityLogV2 entityId={item.entity.id} dataAssetId={item.data_asset.id} />
            </ComposedSheet>
          }
        >
          <Button variant="ghost" size="icon" className="h-5">
            <IconV2FormOutline size={16} />
          </Button>
        </TooltipWrapper>
      </div>
    </div>
  )
}
